import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import LandingPageAppBar from "../components/LandingPageAppBar";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { viewModulesAction } from "../redux/actions/courseActions";

import pro from "../assets/images/profile/ben.jpeg";
import Helmet from 'react-helmet';

import Comment from "../components/Comment";

import ButtonDownload from "../components/common/Download";
import VideoCard from "../components/common/videos";


import { Layout, Menu, Breadcrumb, Affix, BackTop, Card, Skeleton, Button, Drawer, Divider, Tooltip } from 'antd';
import { UserOutlined, LinkedinOutlined, YoutubeOutlined, LeftSquareFilled, DownCircleOutlined, TwitterCircleFilled, DownCircleFilled, GithubOutlined, LaptopOutlined, NotificationOutlined, ArrowUpOutlined } from '@ant-design/icons';

import Footer from "../components/common/Footer";
import MobileFooter from "../components/common/MobileFooter";


const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;
const useStyles = makeStyles((theme) => ({
  root: {},
}));

const style = {
  height: 40,
  width: 40,
  lineHeight: '40px',
  borderRadius: 4,
  backgroundColor: '#038585',
  color: '#fff',
  textAlign: 'center',
  fontWeight: "bolder",
  fontSize: 14,
};

const CoursePage = ({ viewModulesAction, moduleState, match, children }) => {
  const [isLoading, setIsLoading] = useState(true);
  // const [menuKey, setMenuKey] = useState(100);
  const [check, setCheck] = useState(true);
  var menuKey = 100;
  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const [preparedBy, setPreparedBy] = useState("");
  const [preparedByEmail, setPreparedByEmail] = useState("");
  const classes = useStyles();
  const courseName = match.params.courseName;
  useEffect(() => { getAllModules(); }, [])

  const [courseContent, setCourseContent] = useState(courseName);
  const getAllModules = () => {
    viewModulesAction(courseName);
  };
  useEffect(() => {

    if (moduleState.allModulesData) {
      setIsLoading(false);
      console.log(moduleState.allModulesData)
      if (!moduleState.allModulesData.data[0]?.modules[0]) {

        setCourseContent(null);
        setPreparedBy("");
        setPreparedByEmail("");

      }
      else {
        setCourseContent(moduleState.allModulesData.data[0].modules[0].description)
        setPreparedBy(moduleState.allModulesData.data[0].modules[0].user.firstName)
        setPreparedByEmail(moduleState.allModulesData.data[0].modules[0].user.email)
      }
    }

  }, [moduleState]);

  return (
    <>
      <div className="container">
        <Helmet title={`${courseName}`} />
        <LandingPageAppBar />

        <div className="container-column">
          <div>
            <Card style={{ background: "#eff2f5" }}>

              <Layout>
                <Content style={{ padding: '5px 0px 10px 0px' }}>

                  <Layout className="site-layout-background" style={{ padding: '4px 0px 0px 0px', minHeight: "110vh" }}>
                    <Affix offsetTop={100} >
                      <Sider onCollapse={true} className="site-layout-background " width={300} style={{ margin: "0px 0px 0px 0px", overflow: "auto", height: "85vh", background: "#eff2f5", width: "100px" }}>
                        <Affix offsetTop={90}>
                          <Breadcrumb style={{ margin: "0px 0px 0px 10px" }}>
                            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>
                              <Link to="/">Courses</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                              <Link to={`/courses/${courseName}`}>{courseName}</Link>
                            </Breadcrumb.Item>
                          </Breadcrumb>
                        </Affix>
                        <Menu
                          mode="inline"
                          defaultSelectedKeys={["101"]}
                          defaultOpenKeys={['sub1', '1']}
                          style={{ height: '95%', background: "#eff2f5" }}
                          inlineCollapsed={false}

                        >

                          <SubMenu key="sub1" title={courseName} style={{ background: "#eff2f5", fontWeight: "bolder" }}>

                            {isLoading ? (<>
                              <Menu.Item key="1"><Skeleton loading={isLoading} avatar active={true} width="100" /></Menu.Item>
                              <Menu.Item key="1"><Skeleton loading={isLoading} avatar active={true} width="100" /></Menu.Item></>
                            ) :
                              moduleState.allModulesData?.data.map((module, index) => {

                                return (
                                  <SubMenu key={module.week} title={"Week " + module.week} style={{ background: "#eff2f5", fontWeight: "bold" }}>
                                    {
                                      module.modules.map((m, i) => {
                                        // setMenuKey(menuKey+1);
                                        menuKey += 1;
                                        // console.log(menuKey);

                                        return (

                                          <Menu.Item key={menuKey} icon={check ? (<DownCircleFilled />) : (<DownCircleOutlined />)} style={{ background: "#eff2f5", fontWeight: "small" }}  >
                                                  <Tooltip placement="bottom" title={m.name}>
       

                                            <a onClick={() => {
                                              setCourseContent(m.description);
                                              // console.log("here i am!")
                                              setPreparedBy(m.user.firstName);
                                              setPreparedByEmail(m.user.descriptionemail)
                                            }}>{m.name}</a>
                                                  </Tooltip>
                                            
                                            </Menu.Item>

                                        )
                                      })
                                    }


                                  </SubMenu>
                                );
                              })}



                          </SubMenu>


                        </Menu>
                      </Sider>
                    </Affix>
                    <Content style={{ padding: '0 0px', margin: "0px 0px 0px 0px", background: "white", boxShadow: "none" }}>


                      <Card style={{ minHeight: "90vh"}}>
                        <Card.Grid hoverable={false} style={{ width: "100%", boxShadow: "10px red" }}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: !courseContent? "No Modules yet":courseContent
                            }}
                          />
                          <BackTop>
                            <div style={style}><ArrowUpOutlined /></div>
                          </BackTop>
                        </Card.Grid>
                        <Affix offsetTop={300} >
                          <div className="sideDivOther">
                            <LeftSquareFilled onClick={showDrawer} className="leftButton" style={{ fontSize: "40px", marginLeft: "-30px", zIndex: "99", color: "#038585", cursor: "pointer", }} />
                          </div></Affix>

                      </Card>

                      <Card style={{ width: "100%", textAlign: 'center' }}>
                        <Button style={{ width: "20%" }}>Prev</Button>
                        <Button style={{ width: "20%" }}>Next</Button>
                        <Comment style={{ width: "50%" }} />

                      </Card>
                    </Content>
                  </Layout>
                </Content>
                {/* <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer> */}
              </Layout>

            </Card>

          </div>
        </div>
        {/* <Footer />
      <MobileFooter /> */}
      </div>
      <Drawer title="Module Infos" placement="right" onClose={onClose} width="300" visible={visible} style={{ marginTop: "100px", background: "#03858577", overflowY: "auto", maxHeight: "85vh" }} >
        <ButtonDownload />
        <Divider>Course Videos</Divider>
        <div>
          <iframe width="100%" height="170" src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=1">
          </iframe>
          <iframe width="100%" height="170" src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=1">
          </iframe>
          <iframe width="100%" height="170" src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=1">
          </iframe>
          <iframe width="100%" height="170" src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=1">
          </iframe>

        </div>

        <p style={{ padding: "5px 5px 5px 25px", fontWeight: "bolder" }}>Course prepared By:</p>

        {/* <Card hoverable={true} style={{ display: "flex",padding:"0px", textAlign: "center" }}> */}
        <div>
          <div style={{ display: "flex", marginLeft: "-10px" }}>
            <div style={{ width: "50px", height: "50px", background: "white", borderRadius: "50%", overflow: "hidden" }}>
              <img src={pro} height="100%" />
            </div>
            <div style={{ marginLeft: "10px", textAlign: 'center' }}>
              <h4>Eng {preparedBy}</h4>
              <h5>{preparedByEmail}</h5>

              <GithubOutlined style={{ color: "black", fontSize: "25px", margin: "10px" }} />
              <YoutubeOutlined style={{ color: "red", fontSize: "25px", margin: "10px" }} />
              <LinkedinOutlined style={{ color: "blue", fontSize: "25px", margin: "10px" }} />
            </div>
          </div>

        </div>


      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return { moduleState: state.courses.allModules };
};

const mapDispatchToProps = { viewModulesAction };

export default connect(mapStateToProps, mapDispatchToProps)(CoursePage);
